import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "accordion-panel" }
const _hoisted_2 = { class: "accordion-panel__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_RichTextPanel = _resolveComponent("RichTextPanel")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode(_component_v_expansion_panels, {
      elevation: "1",
      class: "accordion-panel__panels"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accordionItems, (item, index) => {
          return (_openBlock(), _createBlock(_component_v_expansion_panel, {
            key: index,
            class: _normalizeClass([{
          'accordion-panel__item-spacing': index < _ctx.accordionItems.length - 1,
        }, "accordion-panel__item"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_RichTextPanel, {
                    content: item.accordionContent.content
                  }, null, 8, ["content"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}